<template>
    <v-dialog v-model="show" width="60vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
        <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
            <v-card-title class="text-h5 lighten-2">
                Entregas OP {{ orderToUpdate.serial }}</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <DeliveryList />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn color="gray" block @click="closeModal()" dark>Cerrar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//vuex
import { mapState, mapMutations } from "vuex";
//components
import DeliveryList from "@/components/dashboard/production-orders/components/DeliveryList.vue";

export default {
    components: {
        DeliveryList,
    },
    data: () => ({
    }),
    props: {
        value: Boolean,
    },
    computed: {
        ...mapState("order", ["orderToUpdate"]),
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        ...mapMutations("order", ["SET_ORDER_TO_UPDATE"]),
        closeModal() {
            this.SET_ORDER_TO_UPDATE(null);
            this.$emit("update");
            this.show = false;
        },
    },
};
</script>

<style scoped>
.decrease {
    background-color: red;
    color: white;
}
</style>